import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'

Vue.use(ElementUI)
Vue.config.productionTip = false
// 👇 新增：配置 axios 并挂载到 Vue 原型
// 配置基础路径（可选，根据后端接口地址调整）

axios.defaults.baseURL = '/api'; // 示例：假设后端接口前缀为 /api
axios.defaults.timeout = 5000; // 设置超时时间（可选）

// 将 axios 挂载到 Vue 原型，通过 this.$axios 访问
Vue.prototype.$axios = axios;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// // 定期检查Token有效期（每分钟检查一次）
// setInterval(() => {
//   if (isTokenExpired()) {
//     // Token已过期，清除并跳转到登录页
//     removeToken();
//     if (router.currentRoute.path !== '/login') {
//       router.push('/login');
//     }
//   }
// }, 60000); // 60秒检查一次